module.exports = __webpack_public_path__ + "img/google.6bb26b3c.png";